import { Component, Input } from "@angular/core";
import { IVehicle } from "@app/interfaces/IVehicle";
import { DeviceParameterType } from "@app/services/device-profile.service";
import './device-profile-vehicle-view.component.scss';

@Component({
    selector: 'device-profile-vehicle-view',
    template: require('./device-profile-vehicle-view.component.html')
})
export class DeviceProfileVehicleViewComponent {

    @Input() vehicle: IVehicle;

    DeviceParameterType = DeviceParameterType;

}
